import { IMAGE_MODEL_STYLE } from "@next-platform/client-common-core";
import { Tab, Tabs } from "@nextui-org/react";
import React from "react";

const TABS_CLASS_NAMES = {
  // Allow wrapping and adjust height
  tabList: "flex-wrap h-auto gap2",
  // Prevent tabs from forcing 100% width; allow them to size by content
  tab: "h-8 px-3 max-w-fit",
};

type ConversationImageStyleTabsProps = {
  modelStyle: string;
  onModelStyleChange: (newModelStyle: string | number) => void;
  isFluxOptionShown: boolean;
  isQwenOptionShown: boolean;
};

/** Model style picker of the conversation image settings modal. */
const ConversationImageStyleTabs = ({ modelStyle, onModelStyleChange, isFluxOptionShown, isQwenOptionShown }: ConversationImageStyleTabsProps) => (
  <Tabs
    size="sm"
    color="primary"
    variant={"bordered"}
    selectedKey={modelStyle}
    onSelectionChange={onModelStyleChange}
    aria-label="Model Style"
    classNames={TABS_CLASS_NAMES}
  >
    <Tab key={IMAGE_MODEL_STYLE.SEMI_REALISTIC} title="Semi Realistic Style" />
    <Tab key={IMAGE_MODEL_STYLE.ANIME} title="Anime Style" />
    {isFluxOptionShown ? <Tab key={IMAGE_MODEL_STYLE.FLUX} title="Flux" /> : null}
    {isFluxOptionShown ? <Tab key={IMAGE_MODEL_STYLE.FLUX_MALE} title="Flux Male" /> : null}
    {isQwenOptionShown ? <Tab key={IMAGE_MODEL_STYLE.QWEN} title="Qwen Image" /> : null}
    {isQwenOptionShown ? <Tab key={IMAGE_MODEL_STYLE.QWEN_MALE} title="Qwen Image Male" /> : null}
  </Tabs>
);

export default React.memo(ConversationImageStyleTabs);
